import { ref } from 'vue';

const DARK_MODE_STORAGE_KEY = 'lais_dark_mode_opt_in_v1';

/**
 * Dark-mode opt-in of the dashboard shell. The preference is per-browser
 * (localStorage) and toggles the `lais-dark` class on <html>.
 */
export function useMinhaLaisDarkMode() {
  const darkModeEnabled = ref(false);

  const readDarkModePref = () => {
    try {
      return window.localStorage.getItem(DARK_MODE_STORAGE_KEY) === '1';
    } catch (error) {
      return false;
    }
  };

  const persistDarkModePref = enabled => {
    try {
      window.localStorage.setItem(DARK_MODE_STORAGE_KEY, enabled ? '1' : '0');
    } catch (error) {
      // ignore
    }
  };

  const applyDarkMode = enabled => {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.toggle('lais-dark', Boolean(enabled));
  };

  const toggleDarkMode = () => {
    darkModeEnabled.value = !darkModeEnabled.value;
    persistDarkModePref(darkModeEnabled.value);
    applyDarkMode(darkModeEnabled.value);
  };

  const initializeDarkMode = () => {
    darkModeEnabled.value = readDarkModePref();
    applyDarkMode(darkModeEnabled.value);
  };

  return { darkModeEnabled, toggleDarkMode, initializeDarkMode };
}
